export const BATCH_IMPORT_ALLOWED_EMAILS = [
  "kajal@aspettoinc.com",
  "robert.davis@aspettoinc.com",
  "katherine.gerner@aspettoinc.com",
  "andrii@aspettoinc.com",
].map((email) => email.trim().toLowerCase());

/**
 * Checks if the currently logged-in user is authorized to perform batch imports.
 * @param {Object|string} user - Current user object from Redux or email string
 * @returns {boolean}
 */
export const canAccessBatchImport = (user) => {
  // return true;
  if (!user) return false;

  let rawEmail = "";
  if (typeof user === "string") {
    rawEmail = user;
  } else if (typeof user === "object") {
    rawEmail =
      user?.email ||
      user?.user?.email ||
      user?.data?.user?.email ||
      user?.data?.email ||
      "";
  }

  if (!rawEmail || typeof rawEmail !== "string") return false;

  const normalizedEmail = rawEmail.trim().toLowerCase();
  return BATCH_IMPORT_ALLOWED_EMAILS.includes(normalizedEmail);
};

export const canAccessProductManagement = canAccessBatchImport;
export const canAccessProductEdit = canAccessBatchImport;
export const canAccessProductCreate = canAccessBatchImport;
